<template>
  <BlSheetMv :active="isShowSuccessClaim" auto-height :is-draggable="false" title="" class="bl-sheet" data-test-id="success-sheet">
    <div slot="content" data-test-id="content">
      <div class="body" data-test-id="body">
        <img :src="$publicUrl(`images/kartu-prakerja/img_small_success.webp`)" height="64" width="64" alt="success-claim" />
        <BlTextAv variation="heading-24" weight="bold">Hore! Hadiah lagi diproses</BlTextAv>
        <BlTextAv variation="body-14">Saldo akan masuk ke e-wallet kamu paling lambat dalam 3 hari kerja.</BlTextAv>
        <BlButtonAv class="btn-blue mt-16 mb-16" data-testid="btn-ok" fullwidth @click="redirectGamificationHomePage">Oke, sip</BlButtonAv>
      </div>
    </div>
  </BlSheetMv>
</template>

<script>
import BlSheetMv from '../temporary-bazaar-components/BlSheetMv/BlSheetMv.vue';
import {BlTextAv, BlButtonAv} from '@bukalapak/bazaar-mweb-latest';

export default {
  name: 'GamificationSuccessClaim',
  components: {
    BlSheetMv,
    BlTextAv,
    BlButtonAv,
  },
  props: {
    isShowSuccessClaim: {
      type: Boolean,
      required: true,
    },
  },
  methods: {
    redirectGamificationHomePage() {
      this.$router.replace({path: '/gamification'});
    },
  },
};
</script>
<style lang="scss" scoped>
.bl-sheet {
  max-width: 480px;
  margin: 0 auto;
  &::v-deep {
    .bl-sheet__icon {
      display: none;
    }
  }
}
.body {
  padding: 16px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
}

.btn-blue {
  background: #332f9e;
  border-radius: 100px;
  border: 2px solid #332f9e;
}
.btn-blue:active {
  background: #4743c9;
  border-color: #4743c9;
}
.btn-blue:hover {
  background: #4743c9;
  border-color: #4743c9;
}
</style>
